<template>
  <nav class="navbar fixted-top navbar-light bg-light">
    <div class="navbar-brand">Backups</div>
    <ul class="nav nav-pages mr-auto">

      <li class="nav-item">
        <router-link class="nav-link"
            :to="{ name: 'Backups', params: { id: this.activeId } }">
          summary
        </router-link>
      </li>

      <li class="nav-item">
        <router-link class="nav-link"
            :to="{ name: 'BackupService', params: { id: this.activeId, service: 'ami' } }">
          ami
        </router-link>
      </li>

      <li class="nav-item">
        <router-link class="nav-link"
            :to="{ name: 'BackupService', params: { id: this.activeId, service: 'ebs' } }">
          ebs
        </router-link>
      </li>

      <li class="nav-item">
        <router-link class="nav-link"
            :to="{ name: 'BackupService', params: { id: this.activeId, service: 'rds' } }">
          rds
        </router-link>
      </li>

      <li class="nav-item">
        <router-link class="nav-link"
            :to="{ name: 'BackupService', params: { id: this.activeId, service: 'rdscluster' } }">
          aurora
        </router-link>
      </li>

      <li class="nav-item">
        <router-link class="nav-link"
            :to="{ name: 'BackupService', params: { id: this.activeId, service: 'redshift' } }">
          redshift
        </router-link>
      </li>

      <li class="nav-item">
        <router-link class="nav-link"
            :to="{ name: 'BackupService', params: { id: this.activeId, service: 'documentdb' } }">
          documentdb
        </router-link>
      </li>

      <li class="nav-item">
        <router-link class="nav-link"
            :to="{ name: 'BackupService', params: { id: this.activeId, service: 's3' } }">
          s3
        </router-link>
      </li>
    </ul>

    <button v-if="downloadBtn"
      type="button"
      class="btn btn-sm btn-primary"
      style="float: right; cursor: pointer;"
      v-on:click="downloadCSV">
      {{text}}
    </button>
  </nav>
</template>

<script>
export default {
  name: 'BackupsNavBar',
  props: [
    'activeId',
    'downloadBtn',
    'text'
  ],
  methods: {
    downloadCSV: function () {
      this.$emit('csv')
    }
  }
}
</script>

<style scoped>
ul.nav a {
  color: rgba(0, 0, 0, 0.5);
}

ul.nav a:hover {
  cursor: pointer;
  color: rgba(0, 0, 0, 1);
}

.router-link-active {
  color: rgba(0, 0, 0, 0.8) !important;
}

</style>



// WEBPACK FOOTER //
// src/components/BackupsNavBar.vue